<div class="card" (click)="cardClicked()">
    <div class="card-content">
        <div class="card-icon">
            <mat-icon svgIcon="medicine_2"></mat-icon>
        </div>
        <div class="card-body">
            <span class="card-title text-capitalize font-weight-bold dark-grey">{{stock.name}}</span>
            <div class="material-barcode text-muted">
                <div class="barcode">
                    SKU {{stock.barcode}}
                </div>
                <div class="material-quantities-and-unit-of-measure text-muted">
                    ({{ stock.quantity || 0}} | {{ stock.unitOfMeasure | uppercase}})
                </div>
            </div>
        </div>
    </div>
</div>